export default "https://lightningbookassetsdev.blob.core.windows.net/lightning-ui/1.46.0/ui/e88b71450254d66e.png"